import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dynamicConditionService } from '../../api/services';
import { getCreateData } from './utils';
import { showToast } from '../../components/Toast/showToast';
import DynamicConditionForm from './DynamicConditionForm';
import { DynamicConditionFormValues } from '../../types/DynamicCondition.types';

const CreateDynamicCondition = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const navigateToListConditions = useCallback(() => {
    navigate('/conditions');
  }, []);

  const handleSubmit = useCallback(async (data: DynamicConditionFormValues) => {
    const ListConditionDepedent =
      data.listDepedentCondition?.map((dependentCondition) => ({
        IdCondicaoDependente: dependentCondition.dependentConditionId?.value || '',
        Values:
          dependentCondition.values?.map((value) => ({
            ValorCondicaoPrincipal: value.principalConditionValue.value || undefined,
            ValorCondicaoDependente: value.dependentConditionValue.value || undefined,
          })) || [],
      })) || [];

    const successfullyUpdated = await dynamicConditionService.create({
      IdCondicaoPrincipal: data.principalConditionId,
      ListaCondicoesDepedentes: ListConditionDepedent,
    });
    if (successfullyUpdated) {
      showToast({
        type: 'success',
        text: 'Sucesso ao cadastrar condição.',
      });
      navigateToListConditions();
    }
  }, []);

  return (
    <>
      <DynamicConditionForm
        type="create"
        initialData={{
          principalConditionId: id as string,
        }}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default CreateDynamicCondition;
